import { useEffect, useState } from 'react';

export default function useIsOnline() {
  const [isOnline, setIsOnline] = useState(navigator?.onLine !== false);

  const onFocus = () => {
    setIsOnline(navigator?.onLine !== false);
  };

  const onLine = () => {
    setIsOnline(true);
  };

  const offLine = () => {
    setIsOnline(false);
  };

  useEffect(() => {
    window.addEventListener('focus', onFocus);
    window.addEventListener('online', onLine);
    window.addEventListener('offline', offLine);
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('online', onLine);
      window.removeEventListener('offline', offLine);
    };
  }, []);

  return isOnline;
}
